import React, { useEffect, useState, useRef } from 'react';
import axiosInstance from '../../../../axiosConfig';
import axios from 'axios';  
import { fetchEarningsTitles } from '../../../../services/earningsApi';
import SummaryDisplay from './SummaryDisplayNews';
import styles from './EarningsPress.module.css'; 
import CustomDropdown from './CustomDropdownEarnings';

const EarningsPress = ({ companyData }) => {
  const [titles, setTitles] = useState([]);
  const [selectedTitleId, setSelectedTitleId] = useState('');
  const [question, setQuestion] = useState('');
  const [loading, setLoading] = useState(true);
  const [conversationHistory, setConversationHistory] = useState([]);
  const [showChat, setShowChat] = useState(false);
  const [summary, setSummary] = useState([]);
  const [loadingHighlights, setLoadingHighlights] = useState(false);
  const [loadingQuestion, setLoadingQuestion] = useState(false);
  const source = useRef(axios.CancelToken.source());

  const handleSelectChange = (selectedId) => {
    setSelectedTitleId(selectedId);
    setConversationHistory([]);
    setQuestion('');
  };

  useEffect(() => {
    const fetchTitles = async () => {
      try {
        const titlesData = await fetchEarningsTitles(companyData.symbol);
        const generateQuarterlyRange = (start, end) => {
          const quarters = [];
          let [startYear, startQuarter] = [parseInt(start.slice(0, 4)), parseInt(start.slice(5))];
          let [endYear, endQuarter] = [parseInt(end.slice(0, 4)), parseInt(end.slice(5))];
  
          while (startYear < endYear || (startYear === endYear && startQuarter <= endQuarter)) {
            quarters.push(`${startYear}Q${startQuarter}`);
            startQuarter++;
            if (startQuarter > 4) {
              startQuarter = 1;
              startYear++;
            }
          }
  
          return quarters.reverse(); // Reverse to match the likely descending order
        };
  
        const latest = titlesData.latest_quarter;
        const end = titlesData.last_quarter ? titlesData.last_quarter : latest;
  
        const constructedTitles = generateQuarterlyRange('2010Q1', end).map((quarter) => ({
          key: quarter,       // if your CustomDropdown uses `option.key`
          title: quarter,
          id: quarter
        }));
        setTitles(constructedTitles);
        setLoading(false);
      } catch (error) {
        console.error(error);
      }
    };
  
    fetchTitles();
  }, [companyData.symbol]);
  

  const handleKeyHighlightsClick = async () => {
    if (selectedTitleId) {
      setLoadingHighlights(true);
      setSummary(null);
      try {
        source.current.cancel('Operation canceled by the user.');
        source.current = axios.CancelToken.source();

        const response = await axiosInstance.post('/earnings_summary/', {
          transcript_id: selectedTitleId,
          symbol: companyData.symbol
        }, {
          cancelToken: source.current.token
        });
 
        const parsedResponse = response.data.response;
        setSummary(parsedResponse);
      } catch (error) {
        if (axios.isCancel(error)) {
        } else {
          console.error(error);
        }
      }
      setLoadingHighlights(false);
    }
  };

  const handleAskQuestionClick = async () => {
    if (selectedTitleId && question) {
      setLoadingQuestion(true);
      try {
        source.current.cancel('Operation canceled by the user.');
        source.current = axios.CancelToken.source();
        const response = await axiosInstance.post('/earnings_chat/', {
          question: question,
          chat_history: conversationHistory,
          transcript_id: selectedTitleId,
          symbol: companyData.symbol
        }, {
          cancelToken: source.current.token,
        });
        setConversationHistory([...conversationHistory, { question: question, answer: response.data.answer }]);
        setQuestion('');
      } catch (error) {
        if (axios.isCancel(error)) {
        } else {
          console.error('Error fetching answer:', error);
        }
      }
      setLoadingQuestion(false);
    }
  };


  const handleChatClick = () => {
    setShowChat(!showChat);
  };

  return (
    <div className={styles.earningsPress}>
      <h3>Earnings Call</h3>
      <CustomDropdown titles={titles} handleSelectChange={handleSelectChange} />
      {loading ? <p>Loading...</p> : !loading && titles.length === 0 && <p>No transcript available</p>}
        <div className={styles.mainContainer}>
          <div className={styles.highlightSection}>
            <button onClick={handleKeyHighlightsClick} className={styles.highlightButton}>Get Analysis</button>
            {loadingHighlights && <p>Loading...</p>}
            {summary && summary.length > 0 && <SummaryDisplay summary={summary} />}
          </div>
          <div className={styles.chatSection}>
            <div>
              <button onClick={handleChatClick} className={styles.chatButton}>Chat</button>
              {showChat && (
                <div className={styles.chatContainer}>
                  {conversationHistory.length > 0 && (
                    <div>
                      <h3>Conversation History:</h3>
                      {conversationHistory.map((qaPair, index) => (
                        <div key={index}>
                          <h4>Q: {qaPair.question}</h4>
                          <div>
                            <SummaryDisplay summary={[qaPair.answer]} />             
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                  <div className={styles.inputSection}>
                    <textarea
                      type="text"
                      value={question}
                      onChange={(e) => setQuestion(e.target.value)}
                      placeholder="Ask about earnings call"
                      className={styles.questionInput}
                      rows="5"
                    />
                    <button onClick={handleAskQuestionClick} className={styles.askButton}>
                      Ask Question
                    </button>
                    {loadingQuestion && <p>Loading...</p>}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
    </div>
  );
}

export default EarningsPress;